import { render, staticRenderFns } from "./index_ssscopy.vue?vue&type=template&id=70938f57&style=height%3A100%25"
import script from "./index_ssscopy.vue?vue&type=script&lang=js"
export * from "./index_ssscopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports